export default __webpack_public_path__ + "static/nft-d3a27c0c9ebe2a112293cc38e899a65e.png";